var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashEditTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 5.50033V4.83366C13.3333 3.90024 13.3333 3.43353 13.1517 3.07701C12.9919 2.7634 12.7369 2.50844 12.4233 2.34865C12.0668 2.16699 11.6001 2.16699 10.6667 2.16699H9.33333C8.39991 2.16699 7.9332 2.16699 7.57668 2.34865C7.26308 2.50844 7.00811 2.7634 6.84832 3.07701C6.66667 3.43353 6.66667 3.90024 6.66667 4.83366V5.50033M8.33333 10.0837V14.2503M11.6667 10.0837V14.2503M2.5 5.50033H17.5M15.8333 5.50033V14.8337C15.8333 16.2338 15.8333 16.9339 15.5608 17.4686C15.3212 17.939 14.9387 18.3215 14.4683 18.5612C13.9335 18.8337 13.2335 18.8337 11.8333 18.8337H8.16667C6.76654 18.8337 6.06647 18.8337 5.53169 18.5612C5.06129 18.3215 4.67883 17.939 4.43915 17.4686C4.16667 16.9339 4.16667 16.2338 4.16667 14.8337V5.50033",
    stroke: "#D92D20",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashEditTeam);
export default __webpack_public_path__ + "static/media/trash-edit-team.4afab7d9cf9463af0bb2b8bda82f1714.svg";
export { ForwardRef as ReactComponent };